import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useTheme } from '../../context/ThemeContext';
import { useCanShowExternalPurchase } from '../../services/paymentSurface';
import { accessBadge } from '../../screens/subscription/agapellaSubscription';
import { fontWeights } from '../../styles/typographyTokens';

import { ACCENT_TEXT } from '../../styles/accentText';
interface Props {
  /** `null` — цена не задана (черновик): бейджа нет. `0` — бесплатно. */
  price: number | null;
  /** Цена, как её печатает карточка («4 900 ₽»). */
  priceLabel?: string | null;
  /** Входит в подписку Agapēlla. Пометки на контенте в бэке пока нет (v3.4 §8). */
  includedInAgapella?: boolean | null;
  testID?: string;
}

/**
 * CORE-1538 — как открывается то, что на карточке (v3.4 §5): «Бесплатно»,
 * «Входит в Agapēlla», «Купить отдельно · цена».
 *
 * На Android вне РФ и на iOS слов о покупке нет (CORE-1535) — остаётся цена.
 * Рендерить только тому, кому сервер включил подписку: без неё «отдельно» не
 * от чего отличать.
 */
export const AccessBadge: React.FC<Props> = ({ price, priceLabel, includedInAgapella, testID }) => {
  const { colors: C } = useTheme();
  const canPay = useCanShowExternalPurchase();
  const badge = accessBadge({ price, priceLabel, includedInAgapella }, canPay);
  if (!badge) return null;

  if (badge.kind === 'price') {
    return <Text style={[s.price, { color: C.textPrimary }]} testID={testID}>{badge.label}</Text>;
  }
  const included = badge.kind === 'included';
  return (
    <View
      style={[s.pill, { borderColor: included ? C.solar : C.border, backgroundColor: C.backgroundSoft }]}
      testID={testID}
    >
      <Text style={[s.label, { color: included ? ACCENT_TEXT : C.textPrimary }]}>{badge.label}</Text>
    </View>
  );
};

const s = StyleSheet.create({
  pill: { alignSelf: 'flex-start', borderWidth: 1, borderRadius: 999, paddingHorizontal: 12, paddingVertical: 5 },
  label: { fontSize: 14, fontWeight: fontWeights.bold },
  price: { fontSize: 17, fontWeight: fontWeights.bold },
});
